export default __webpack_public_path__ + "img/d9212524ff27fad61a7dac34424f9705.svg";